import { Link } from "react-router-dom";
import { hotAnimes } from "@/mocks/articles";

export default function HotSection() {
  return (
    <section id="hot" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-700">
              <i className="ri-fire-fill"></i> 本周热播
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-900 md:text-3xl">热门新番推荐</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">追番必备 · 高分口碑新番一网打尽</p>
          </div>
          <Link to="/category" className="inline-flex items-center whitespace-nowrap text-sm font-medium text-primary-600 transition hover:text-primary-700">
            更多新番 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-6">
          {hotAnimes.map((a) => (
            <Link key={a.id} to={`/category/${a.categorySlug}`} className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:border-primary-300">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={a.image}
                  alt={`${a.title} - 动漫网`}
                  title={`${a.title} - 动漫网`}
                  loading="lazy"
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-full bg-secondary-500 px-2.5 py-0.5 text-xs font-medium text-background-50">{a.tag}</span>
                <span className="absolute bottom-2 right-2 rounded bg-black/60 px-2 py-0.5 text-xs font-semibold text-yellow-300">{a.score} 分</span>
              </div>
              <div className="p-3">
                <h3 className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700">{a.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{a.category} · 全 {a.episodes} 话</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}